export interface FaqSchemaItem {
  question: string
  answer: string
}

interface SchemaGraph {
  '@context': string
  '@graph': Record<string, unknown>[]
}

export const buildFaqPageSchema = (pageUrl: string, faqs: FaqSchemaItem[]) => ({
  '@type': 'FAQPage',
  '@id': `${pageUrl}#faq`,
  mainEntity: faqs.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
})

export const withFaqPageSchema = (serviceSchema: SchemaGraph, pageUrl: string, faqs: FaqSchemaItem[]) => ({
  '@context': serviceSchema['@context'],
  '@graph': [...serviceSchema['@graph'], buildFaqPageSchema(pageUrl, faqs)],
})

export const toFaqList = (
  sectionTitle: string,
  sectionRead: string,
  items: FaqSchemaItem[],
) => ({
  sectionTitle,
  sectionRead,
  faq: items.map(({ question, answer }) => ({
    title: question,
    text: answer,
  })),
})
